import 'whatwg-fetch'

const BASE_URI = 'https://api.postcodes.io/postcodes'

const headers = {'Content-Type': 'application/json'}

const get = path => (
  fetch(path, {method: 'GET', headers})
)

const post = (path, body) => (
  fetch(path, {method: 'POST', headers, body})
)

export const postcodesService = {
  postcodes: body =>
    post(`${BASE_URI}/`, JSON.stringify({postcodes: body})),
  autocomplete: input =>
    get(`${BASE_URI}/${input}/autocomplete`),
}
